import { type User } from "@/types";
import { logError } from "@/utils/logger";

import { useLocalStorage } from "../../../../src/hooks/useLocalStorage";

export function useRecentSearchedUsers() {
  const [recentSearchedUsers, setRecentSearchedUsers] = useLocalStorage<
    User<true>[]
  >("recentSearchedUsers", []);

  const addRecentUser = (user: User<true>) => {
    try {
      const filteredUsers = recentSearchedUsers.filter(
        (u: User<true>) => u.id !== user.id,
      );

      const updatedUsers = [user, ...filteredUsers];

      const fianlUsers = updatedUsers.slice(0, 10);

      setRecentSearchedUsers(fianlUsers);
    } catch (error) {
      logError("error with update and setting user in the list", {
        user,
        error,
      });
    }
  };

  return {
    recentSearchedUsers,
    addRecentUser,
  };
}
